/* src/app/private/components/view/campus/create-campus/create-campus.component.scss */
/*# sourceMappingURL=create-campus.component.css.map */
